import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=4238e67e&scoped=true"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"
import style0 from "./Region.vue?vue&type=style&index=0&id=4238e67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238e67e",
  null
  
)

export default component.exports